import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  image: {
    width: 112,
    height: 112,
    marginRight: spacing(2),
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  textWrap: {
    wordBreak: 'break-word',
    wordWrap: 'break-word',
  },
}));

export default useStyles;
